import { microserviceFinalizeApi } from "./microserviceFinalizeAPI";

export const finalize = microserviceFinalizeApi.injectEndpoints({
  endpoints: (builder) => ({
    sendRevoke: builder.mutation({
      query: (data) => ({
        url: `/revocatecertificate`,
        method: "POST",
        body: data,
      }),  
      extraOptions: { maxRetries: 0 },
    })
  })
});

export const {
  useSendRevokeMutation,
} = finalize;
